import avatar1 from '../assets/landing/voice-avatar-1.png'
import avatar2 from '../assets/landing/voice-avatar-2.png'
import avatar3 from '../assets/landing/voice-avatar-3.png'
import avatar4 from '../assets/landing/voice-avatar-4.png'
import avatar5 from '../assets/landing/voice-avatar-5.png'
import avatar6 from '../assets/landing/voice-avatar-6.png'

type Voice = {
  title: string
  body: string
  author: string
  avatar: string
}

const VOICES: Voice[] = [
  {
    title: 'わが家の毎日の楽しみです',
    body: '4人兄弟のわが家。寝る前になると自然と画面の前に集まり、みんなで写真を見るように。思い出を一緒に眺める時間が、日常を彩ってくれています。',
    author: 'K.Mさん (8,5,3,0歳のパパ)',
    avatar: avatar1,
  },
  {
    title: '動画が一緒に見れて嬉しい',
    body: 'これまであまり見る機会がなかった動画が見れて楽しいです。子どもが画面を指さして一生懸命おしゃべりしてくれる姿がとてもかわいいです。',
    author: 'R.Tさん (1歳のママ)',
    avatar: avatar2,
  },
  {
    title: '娘との会話が弾みます',
    body: '娘が保育園の写真を一緒に見ながら、「この子はね…」とお友達のことを教えてくれます。とても楽しそうに話してくれて、会話が尽きません。',
    author: 'H.Kさん (3歳のママ)',
    avatar: avatar3,
  },
  {
    title: '並んで映る姿に感動しました',
    body: '2つのアルバムの写真をまとめて映せるので、姉の子どもとわが家の子どもの写真が並んで表示されることも。今までになかった新しい体験で感動しました。',
    author: 'M.Hさん (6,3歳のパパ)',
    avatar: avatar4,
  },
  {
    title: '思いがけない発見があります',
    body: '今まで見れていなかった昔の写真がふと表示されて、「こんな瞬間もあったんだ」と再発見。幸せな気持ちになることが増えました。',
    author: 'A.Nさん (4歳のパパ)',
    avatar: avatar5,
  },
  {
    title: 'みてねの写真が大きくきれいに',
    body: 'いつもはスマホで見ている写真がフレームに表示された時に「大きい〜！綺麗！」と感じました。光沢の感じも良くて満足感があります。',
    author: 'J.Oさん (6歳のママ)',
    avatar: avatar6,
  },
]

function VoiceCard({ voice }: { voice: Voice }) {
  return (
    <div className='flex-shrink-0 w-[294px] h-[240px] bg-white rounded-lg shadow-[0px_2px_10px_0px_rgba(0,0,0,0.1)] px-6 py-8 flex flex-col justify-center gap-2'>
      <p className='text-base font-semibold text-[#202020] leading-[25px] tracking-[-0.41px] line-clamp-2'>
        {voice.title}
      </p>
      <p className='text-sm font-light text-[#202020] leading-[22px] tracking-[-0.24px] flex-1 overflow-hidden line-clamp-4'>
        {voice.body}
      </p>
      <div className='flex items-end justify-end gap-2 mt-auto'>
        <p className='text-xs font-light text-[#8d8d8d] leading-[18px] text-right flex-1'>
          {voice.author}
        </p>
        <img
          src={voice.avatar}
          alt=''
          className='w-[50px] h-[50px] rounded-full object-cover border-2 border-white'
          loading='lazy'
        />
      </div>
    </div>
  )
}

export default function UserVoicesSection() {
  return (
    <section className='bg-[#fefaf0] py-10 flex flex-col gap-6'>
      <div className='px-4 flex flex-col gap-4'>
        <div className='flex flex-col gap-1 text-center'>
          <p className='text-[12.8px] font-semibold text-mi-on-surface-accent-secondary leading-[1.6]'>
            お使いのみなさまの声
          </p>
          <h2 className='text-2xl font-semibold text-[#202c19] leading-[1.4]'>
            こんな時間が生まれました！
          </h2>
        </div>
        <p className='text-base font-light text-[#202020] leading-[1.6] text-center'>
          おもいでフォトフレームのある暮らし。
          <br />
          その心地よさを、
          <br />
          実際にお使いのみなさまの声とともに
          <br />
          ご紹介します。
        </p>
      </div>

      <div
        className='hide-scrollbar flex gap-4 overflow-x-auto px-[9px] pb-1'
      >
        {VOICES.map((voice, i) => (
          <VoiceCard key={i} voice={voice} />
        ))}
      </div>
    </section>
  )
}
